import middleware from './middleware'
import AuthLayout from '@/layout/auth'

const { guest } = middleware

export default [
  {
    path: '/auth',
    component: AuthLayout,
    redirect: '/auth/login',
    children: [
      {
        path: 'login',
        component: () => import('@views/auth/login'),
        name: 'auth.login',
        meta: {
          title: 'Login',
          middleware: [guest]
        }
      },
      {
        path: 'forgot-password',
        component: () => import('@views/auth/forgot_password'),
        name: 'auth.forgot-password',
        meta: {
          title: 'Forgot password',
          middleware: [guest]
        }
      },
      {
        path: 'reset-password',
        component: () => import('@views/auth/reset_password'),
        name: 'auth.reset-password',
        meta: {
          title: 'Reset password',
          middleware: [guest]
        }
      }
    ]
  }
]
